import UserBadge from "./UserBadge.vue";
export default UserBadge;
